import { useMutation } from "react-query";
import { _t } from "../../../../../modules/Common/components/InjectIntlContext";
import { notify, notifyMap } from "../../../../../common/helpers";
import { postContacts } from "./api";

export const usePostContacts = () => {
  const messageSentTranslated = _t("message_sent");
  return useMutation(postContacts, {
    onSuccess: (data, variables) => {
      if (data.status === "ok") {
        notify("success", messageSentTranslated);
      } else {
        notifyMap("error", data.message);
      }
    },
    onError: (error) => {
      notify("error", "error");
    },
  });
};
